import React, { lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { roles } from "./firebase-config";
import { SnackbarProvider } from "./Application/admin/components/SnackbarProvider";
import ProtectedRoute from "./utils/ProtectedRoutes";
import Checkout from "./Application/Pages/SamplePayment";

const LoginPage = lazy(() => import("./Application/Auth/index"));
const ClientPortal = lazy(() => import("./Application/client/index"));
const AdminRedirectPage = lazy(() => import("./utils/AdminRedirect"));
const AdminPortal = lazy(() => import("./Application/admin/index"));
const ProductsHeader = lazy(() => import("./Components/ProductHeader/index"));
const DynamicProductPage = lazy(() =>
  import("./Application/Pages/DynamicProductPage/index")
);
const ViewCart = lazy(() =>
  import("./Application/Pages/CartViewingPage/index")
);
const ProductViewPage = lazy(() =>
  import("./Application/Pages/ProductView/index")
);
const PaymentPage = lazy(() => import("./Application/Pages/PaymentPage/index"));
const Footer = lazy(() => import("./Components/Footer/index"));
const AboutUs = lazy(() => import("./Application/Pages/AboutUs"));
const YourOrders = lazy(() => import("./Application/Pages/YourOrders"));
const PrivacyPolicy = lazy(() =>
  import("./Application/Pages/PrivacyPolicy/PrivacyPolicy")
);
const TermsPolicy = lazy(() =>
  import("./Application/Pages/TermsConditions/TermsPolicy")
);
const PaymentRedirect = lazy(() =>
  import("./Application/Pages/PaymentRedirect")
);
// const WelcomeScreen = lazy(() =>
//   import("./Application/Pages/WelcomeScreen/WelcomeScreen")
// );
const UnderMaintenance = lazy(() => import("./Application/Pages/Maintainance"));
const EmailVerificationPage = lazy(() =>
  import("./Application/Pages/EmailVerificationPage/EmailVerificationPage")
);

const App = () => {
  // const [showWelcome, setShowWelcome] = useState(false);

  // useEffect(() => {
  //   const hasSeenWelcome = localStorage.getItem("hasSeenWelcome");

  //   if (!hasSeenWelcome) {
  //     setShowWelcome(true);
  //   }
  // }, []);

  // const handleContinue = () => {
  //   localStorage.setItem("hasSeenWelcome", "true");
  //   setShowWelcome(false);
  // };

  //  showWelcome ? (
  //   <Suspense
  //     fallback={
  //       <div className="loader-overlay">
  //         <div className="circular-loader"></div>
  //       </div>
  //     }
  //   >
  //     <WelcomeScreen onContinue={handleContinue} />
  //   </Suspense>
  // ) : (
  return (
    <AuthProvider>
      <SnackbarProvider>
        <Router>
          <Routes>
            <Route path="/Maintainance" element={<UnderMaintenance />} />
            <Route path="/productheader" element={<ProductsHeader />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/product/:category" element={<DynamicProductPage />} />
            <Route
              path="/viewcart"
              element={
                <ProtectedRoute allowedRoles={[roles.CUSTOMER, roles.ADMIN]}>
                  <ViewCart />
                </ProtectedRoute>
              }
            />
            <Route
              path="/yourorders"
              element={
                <ProtectedRoute allowedRoles={[roles.CUSTOMER, roles.ADMIN]}>
                  <YourOrders />
                </ProtectedRoute>
              }
            />
            
            <Route path="/paymentRedirect" element={<PaymentRedirect />} />
            <Route path="/product-viewpage" element={<ProductViewPage />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/footer" element={<Footer />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-shippping-refunds" element={<TermsPolicy />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/client" element={<ClientPortal />} />
            <Route path="/admin-redirect" element={<AdminRedirectPage />} />
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute allowedRoles={[roles.ADMIN]}>
                  <AdminPortal />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/product/allproducts" />} />
            {/* <Route path="*" element={<Navigate to="/Maintainance" />} /> */}
            <Route path="/verify-email" element={<EmailVerificationPage />} />
          </Routes>
        </Router>
      </SnackbarProvider>
    </AuthProvider>
  );
  // );
};

export default App;
